import { render, staticRenderFns } from "./ConsultationManage.vue?vue&type=template&id=379391b2&scoped=true"
import script from "./ConsultationManage.vue?vue&type=script&lang=js"
export * from "./ConsultationManage.vue?vue&type=script&lang=js"
import style0 from "./ConsultationManage.vue?vue&type=style&index=0&id=379391b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379391b2",
  null
  
)

export default component.exports